import { FC, SVGProps } from 'react';

const FileDownloadOutlineIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M10.5 8.25V10.5H1.5V8.25H0V10.5C0 11.325 0.675 12 1.5 12H10.5C11.325 12 12 11.325 12 10.5V8.25H10.5ZM9.75 5.25L8.6925 4.1925L6.75 6.1275V0H5.25V6.1275L3.3075 4.1925L2.25 5.25L6 9L9.75 5.25Z"
        fill="#014361"
      />
    </svg>
  );
};

export default FileDownloadOutlineIcon;
